export const TOKEN_KEY = 'token';
export const TOKEN_TIMESTAMP_KEY = 'token_timestamp';
export const WEB_SESSION_DURATION_MS = 8 * 60 * 60 * 1000; // 8 hours
